/**
 * 
 * @param {*} user 
 * @param {*} carrier 
 * @returns 
 */
const getOocPolicyNumber = (user, carrier) => {
    if (user.oocPolicyNumber) {
        return user.oocPolicyNumber;
    }

    /**
     * If no OOC Policy Number stored then check for carrier defaults
     */
    if (carrier === "AIG") {
        return user.isStudentGroup ? "9429934" : "9429103";
    }

    if (carrier === "Desjardins") {
        return user.groupNum;
    }

    return null;
};

export default getOocPolicyNumber;